module.exports = __webpack_public_path__ + "static/media/notify_channel.1a64130d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/notify_channel.svg
// module id = 407
// module chunks = 0